<template>
  <form-wrapper :validator="$v.items">
    <div class="row">
      <div class="col-md-7"/>
      <div class="col-md-5">
        <div class="row">
          <div class="col-md-6">
            <label style="margin-right:3em">
              {{ $t('message.lblPrijmy') }}
            </label>
          </div>
          <div class="col-md-6">
            <label style="margin-left:1em">
              {{ $t('message.lblVydavky') }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="input in inputs"
      :key="input.nameP"
      class="row par7-controls">
      <div class="col-md-9">
        <text-group
          :m="items"
          :placeholder="input.placeholder"
          :disabled="input.disabled"
          :name="input.nameP"
          :label="input.label"
          :input-cols="3"/>
      </div>
      <div class="col-md-3">
        <text-group
          :m="items"
          :disabled="input.disabled"
          :placeholder="input.placeholder"
          :name="input.nameV"
          :input-cols="10"
          label=""/>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-9">
        <text-group
          :m="items"
          class="lastText"
          name="r13_prijmy"
          :input-cols="3"
          :label="$t('message.lblPrijmyDosiahnute')"/>
      </div>
    </div>

    <b-button
      class="btn-primary"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>

  </form-wrapper>
</template>

<script>
import { minValue, maxValue, decimal } from 'vuelidate/lib/validators';
import textGroup from '@/components/extractor/moneyTextGroup.vue';
import restEditor from '@/mixins/restEditor';

export default {
  components: {
    textGroup,
  },

  mixins: [restEditor],
  data() {
    const id = null;
    const parent = this.$route.params.userId;
    return {
      id,
      parent,
      items: {
        id: null,
        parent: null,
        r3_prijmy: null,
        r3_vydavky: null,
        r7_prijmy: null,
        r7_vydavky: null,
        r8_prijmy: null,
        r8_vydavky: null,
        r9_prijmy: null,
        r9_vydavky: null,
        r13_prijmy: null,
      },
      inputs: {
        1: {
          disabled: true, placeholder: this.$t('message.plchZrD'), nameP: 'r1_prijmy', nameV: 'r1_vydavky', label: this.$t('message.tuz7r1'),
        },
        2: {
          disabled: true, placeholder: this.$t('message.plchZrD'), nameP: 'r2_prijmy', nameV: 'r2_vydavky', label: this.$t('message.tuz7r2'),
        },
        3: {
          nameP: 'r3_prijmy', nameV: 'r3_vydavky', label: this.$t('message.tuz7r3'),
        },
        4: {
          disabled: true, placeholder: this.$t('message.plchZrD'), nameP: 'r4_prijmy', nameV: 'r4_vydavky', label: this.$t('message.tuz7r4'),
        },
        5: {
          disabled: true, placeholder: this.$t('message.plchZrD'), nameP: 'r5_prijmy', nameV: 'r5_vydavky', label: this.$t('message.tuz7r5'),
        },
        6: {
          disabled: true, placeholder: this.$t('message.plchZrD'), nameP: 'r6_prijmy', nameV: 'r6_vydavky', label: this.$t('message.tuz7r6'),
        },
        7: {
          nameP: 'r7_prijmy', nameV: 'r7_vydavky', label: this.$t('message.tuz7r7'),
        },
        8: {
          nameP: 'r8_prijmy', nameV: 'r8_vydavky', label: this.$t('message.tuz7r8'),
        },
        9: {
          nameP: 'r9_prijmy', nameV: 'r9_vydavky', label: this.$t('message.tuz7r9'),
        },
        10: {
          disabled: true, placeholder: this.$t('message.plchZrD'), nameP: 'r10_prijmy', nameV: 'r10_vydavky', label: this.$t('message.tuz7r10'),
        },
      },
    };
  },

  validations: {
    items: {
      r3_prijmy: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999999.99),
      },
      r3_vydavky: {
        decimal,
        minValue: minValue(0),
        maxValueToPrijmy: (value, vm) =>
          (value ? (parseFloat(value) <= parseFloat(vm.r3_prijmy)) : true),
      },
      r7_prijmy: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999999.99),
      },
      r7_vydavky: {
        decimal,
        minValue: minValue(0),
        maxValueToPrijmy: (value, vm) =>
          (value ? (parseFloat(value) <= parseFloat(vm.r7_prijmy)) : true),
      },
      r8_prijmy: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999999.99),
      },
      r8_vydavky: {
        decimal,
        minValue: minValue(0),
        maxValueToPrijmy: (value, vm) =>
          (value ? (parseFloat(value) <= parseFloat(vm.r8_prijmy)) : true),
      },
      r9_prijmy: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(999999.99),
      },
      r9_vydavky: {
        decimal,
        minValue: minValue(0),
        maxValueToPrijmy: (value, vm) =>
          (value ? (parseFloat(value) <= parseFloat(vm.r9_prijmy)) : true),
      },
      r13_prijmy: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(9999999.99),
      },
    },
  },

  methods: {
    async processGet() {
      this.id = await this.restDataSource.getSposobId(this.parent, 7);
      if (this.id !== null) {
        const incomes = await this.restDataSource.getData(this.id, 'par7inland');

        this.items.id = incomes.id;
        this.items.parent = incomes.parent;
        this.items.r3_prijmy = incomes.r3_prijmy;
        this.items.r3_vydavky = incomes.r3_vydavky;
        this.items.r7_prijmy = incomes.r7_prijmy;
        this.items.r7_vydavky = incomes.r7_vydavky;
        this.items.r8_prijmy = incomes.r8_prijmy;
        this.items.r8_vydavky = incomes.r8_vydavky;
        this.items.r9_prijmy = incomes.r9_prijmy;
        this.items.r9_vydavky = incomes.r9_vydavky;
        this.items.r13_prijmy = incomes.r13_prijmy;
      }
    },
    async processSave() {
      if (this.id === null) {
        this.items.parent = this.parent;
        await this.restDataSource.createData(this.items, 'par7inland');
      } else {
        await this.restDataSource.updateItem(this.items, `par7inland/${this.id}`);
      }
    },
  },

};
</script>

<style>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.add-item {
    float: left;
}
.text-muted {
    color: #777;
}
.lastText {
  padding-right: 11px;
}

.par7-controls .form-control[disabled] {
  font-size: 15px !important;
}
</style>
